"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _PopupScreen = _interopRequireDefault(require("../../02_molecules/PopupScreen"));

var _LanguageSettingsWidget = _interopRequireDefault(require("../../03_organisms/LanguageSettingsWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MobileLanguageSettingsPage = function MobileLanguageSettingsPage(_ref) {
  var lang = _ref.lang,
      supportedLanguages = _ref.supportedLanguages,
      _ref$onLangChange = _ref.onLangChange,
      onLangChange = _ref$onLangChange === void 0 ? function () {} : _ref$onLangChange,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      t = _ref.translator;
  return /*#__PURE__*/_react["default"].createElement(_PopupScreen["default"], {
    title: t('Language settings'),
    onBack: onBack,
    leftIcon: "close"
  }, /*#__PURE__*/_react["default"].createElement(_LanguageSettingsWidget["default"], {
    lang: lang,
    supportedLanguages: supportedLanguages,
    onLangChange: onLangChange,
    onBack: onBack,
    translator: t
  }));
};

var _default = MobileLanguageSettingsPage;
exports["default"] = _default;